import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/mobile.css';
import './styles/top10.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Previne bounce scroll no iOS - EXCETO na landing page
document.addEventListener('touchmove', function(e) {
  if (e.target.closest('.main-content--mobile, .sidebar--mobile, .media-modal, .modal-overlay, .landing-page')) {
    return;
  }
  // Previne scroll do body
  e.preventDefault();
}, { passive: false });

// Prevenir zoom duplo-tap no iOS (300ms delay)
let lastTouchEnd = 0;
document.addEventListener('touchend', function(event) {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registrado com sucesso:', registration.scope);

        // Verifica atualizações a cada 1 hora
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);

        // Escuta por atualizações do SW
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[PWA] Nova versão disponível! Recarregue a página para atualizar.');
              // Aqui você pode mostrar um toast para o usuário atualizar
            }
          });
        });
      })
      .catch((error) => {
        console.log('[PWA] Falha ao registrar Service Worker:', error);
      });
  });
}
